import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  Fragment,
} from "react";
import PropTypes from "prop-types";
import { CredsContext, HelpModeContext } from "./Contexts";
import { DataManager, Query } from "@syncfusion/ej2-data";
import Tools from "./JNSTools";
import GlobalData from "./GlobalData";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  ColumnMenu,
  Edit,
  Filter,
  Inject,
  Sort,
  Group,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import { enableRipple } from "@syncfusion/ej2-base";
import Tour from "./Tour";
import RequirementsEditor from "./RequirementsEditor";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import ProjectTitleBar from "./ProjectTitleBar_ably";
import { DesktopDatePicker } from "@mui/x-date-pickers-pro";
import dayjs from "dayjs";
import "./styles/Requirements.css";

function RAIDComponent(props) {
  let oadaSettings;
  const settingsRaw = localStorage.getItem("oadaSettings");
  if (settingsRaw) {
    oadaSettings = JSON.parse(settingsRaw);
  }
  const helpMode = useContext(HelpModeContext).mode;
  const creds = useContext(CredsContext).creds;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const [pageContent, setPageContent] = useState();
  const grid = useRef();
  const editMode = useRef(false);
  let fieldName;
  const newIssueInitial = {
    name: "",
    synopsis: "",
    stage: "",
    category: "",
    severity: "",
    id: "",
    stageId: "",
    categoryId: "",
    severityId: "",
    date: "",
    dateReq: "",
    dateExp: "",
    dateRes: "",
    assignee: "",
  };
  const newIssue = useRef(newIssueInitial);
  const projectTasks = useRef([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const useExpectedDate = false; // future release, change this to a localStorage setting
  const idToDelete = useRef();
  const OPEN_STAGE_ID = useRef();
  const ASSIGNED_STAGE_ID = useRef();
  const PENDING_STAGE_ID = useRef();
  const RESOLVED_STAGE_ID = useRef();
  const DECISION_NEEDED_STAGE_ID = useRef();
  const DECISION_MADE_STAGE_ID = useRef();
  const RISK_CATEGORY_ID = useRef();
  const ACTION_CATEGORY_ID = useRef();
  const ISSUE_CATEGORY_ID = useRef();
  const DECISION_CATEGORY_ID = useRef();
  const HIGH_SEVERITY_ID = useRef();
  const MEDIUM_SEVERITY_ID = useRef();
  const LOW_SEVERITY_ID = useRef();
  const TOUR_ID = "RAID";
  let resolvedRef;

  if (oadaSettings) {
    OPEN_STAGE_ID.current = oadaSettings["openStageDropdown_options"];
    ASSIGNED_STAGE_ID.current = oadaSettings["assignedStageDropdown_options"];
    PENDING_STAGE_ID.current = oadaSettings["pendingStageDropdown_options"];
    RESOLVED_STAGE_ID.current = oadaSettings["resolvedStageDropdown_options"];
    DECISION_NEEDED_STAGE_ID.current =
      oadaSettings["decisionNeededStageDropdown_options"];
    DECISION_MADE_STAGE_ID.current =
      oadaSettings["decisionMadeStageDropdown_options"];
    RISK_CATEGORY_ID.current = oadaSettings["riskCategoryDropdown_options"];
    ACTION_CATEGORY_ID.current = oadaSettings["actionCategoryDropdown_options"];
    ISSUE_CATEGORY_ID.current = oadaSettings["issueCategoryDropdown_options"];
    DECISION_CATEGORY_ID.current =
      oadaSettings["decisionCategoryDropdown_options"];
    HIGH_SEVERITY_ID.current = oadaSettings["highSeverityDropdown_options"];
    MEDIUM_SEVERITY_ID.current = oadaSettings["mediumSeverityDropdown_options"];
    LOW_SEVERITY_ID.current = oadaSettings["lowSeverityDropdown_options"];
  }

  const stageOptions =
    props.raidType == "decision"
      ? [
          { name: "Awaiting Decision", id: DECISION_NEEDED_STAGE_ID.current },
          { name: "Decision Made", id: DECISION_MADE_STAGE_ID.current },
        ]
      : [
          { name: "Open", id: OPEN_STAGE_ID.current },
          { name: "Assigned", id: ASSIGNED_STAGE_ID.current },
          { name: "Pending", id: PENDING_STAGE_ID.current },
          { name: "Resolved", id: RESOLVED_STAGE_ID.current },
        ];

  const categoryOptions = [
    { name: "Risk", id: RISK_CATEGORY_ID.current },
    { name: "Action", id: ACTION_CATEGORY_ID.current },
    { name: "Issue", id: ISSUE_CATEGORY_ID.current },
    { name: "Decision", id: DECISION_CATEGORY_ID.current },
  ];

  const severityOptions = [
    { name: "High", id: HIGH_SEVERITY_ID.current },
    { name: "Medium", id: MEDIUM_SEVERITY_ID.current },
    { name: "Low", id: LOW_SEVERITY_ID.current },
    { name: "", id: 5 },
  ];

  const userOptions = [];
  props.projectTeam.forEach((elem) => {
    const spaceIndex = elem.name.trim().indexOf(" ");
    const firstName = elem.name.trim().substring(0, spaceIndex);
    const lastName = elem.name.trim().substring(spaceIndex + 1);
    userOptions.push({ name: lastName + ", " + firstName, id: elem.id });
  });

  const dropdownFieldDef = { text: "name", value: "id" };
  const initialTourState = {
    key: new Date(),
    run: false,
    loading: false,
    stepIndex: 0,
    steps: [
      {
        target: ".e-icons.e-columnmenu",
        content: (
          <Box>
            <p>Clicking this icon provides column-based features, including:</p>
            <ul>
              <li>Auto fit column</li>
              <li>Sort column in ascending or descending order</li>
              <li>Set column visibility</li>
              <li>Filter column</li>
            </ul>
          </Box>
        ),
        disableBeacon: true,
      },
      {
        target: ".tour-stop-2",
        content: (
          <Box>
            <p>
              Clicking the Synopsis of a RAID item will open that item&apos;s
              edit screen
            </p>
          </Box>
        ),
      },
    ],
  };
  if (props.raidType != "all") {
    initialTourState.steps.push({
      target: ".tour-stop-3",
      content: (
        <Box>
          <p>Click this button to add a new RAID item</p>
        </Box>
      ),
    });
  }
  const [openRequiredFieldNotification, setOpenRequiredFieldNotification] =
    useState(false);
  const [dirty, isDirty] = useState(false);

  enableRipple(true);

  const handleTextFieldValueChange = (event) => {
    newIssue.current[event.target.id] = event.target.value;
  };

  const handleStageValueChange = (event) => {
    newIssue.current.stageId = event.itemData.id;
    if (event.itemData.id == RESOLVED_STAGE_ID.current && resolvedRef) {
      newIssue.current.dateRes = new Date();
      resolvedRef.value = new Date();
      //isDirty(!dirty);
    }
  };

  const handleAssigneeValueChange = (event) => {
    newIssue.current.userId = event.itemData.id;
  };

  const handleCategoryValueChange = (event) => {
    newIssue.current.categoryId = event.itemData.id;
  };

  const handleSeverityValueChange = (event) => {
    newIssue.current.severityId = event.itemData ? event.itemData.id : -1;
  };

  const handleTaskValueChange = (event) => {
    newIssue.current.projectTaskId = event.itemData ? event.itemData.id : -1;
    newIssue.current.newTaskName = event.itemData ? event.itemData.name : "";
  };

  const handleDateReqValueChange = (event) => {
    newIssue.current.dateReq = event.$d;
  };

  const handleDateExpValueChange = (event) => {
    newIssue.current.dateExp = event.$d;
  };

  const handleDateResValueChange = (event) => {
    newIssue.current.dateRes = event.$d;
  };

  const handleAdd = (event) => {
    console.log(event.target.dataset.raidtype);
    newIssue.current.category =
      event.target.dataset.raidtype.charAt(0).toUpperCase() +
      event.target.dataset.raidtype.slice(1);
    const categoryOption = categoryOptions.find(
      (elem) => elem.name == newIssue.current.category,
    );
    newIssue.current.categoryId = categoryOption.id;
    setOpenDialog(true);
  };

  const handleOpen = (issueRecord) => {
    const stageArray = JSON.parse(
      localStorage.getItem(creds.company + "|IssueStage"),
    );
    const severityArray = JSON.parse(
      localStorage.getItem(creds.company + "|IssueSeverity"),
    );
    const userArray = JSON.parse(localStorage.getItem(creds.company + "|User"));

    //if (event.target.dataset.issuerecord) {
    //const issueRecord = JSON.parse(event.target.dataset.issuerecord);

    newIssue.current.name = issueRecord.name;
    newIssue.current.synopsis = issueRecord.description;
    newIssue.current.id = issueRecord.id;
    newIssue.current.stageId = issueRecord.issue_stage_id;
    newIssue.current.userId = issueRecord.user_id;
    newIssue.current.date = issueRecord.date;
    newIssue.current.details = issueRecord.oada_req_details__c;
    newIssue.current.dateReq = issueRecord.date_resolution_required;
    newIssue.current.dateExp = issueRecord.date_resolution_expected;
    newIssue.current.dateRes = issueRecord.date_resolved;
    newIssue.current.categoryId = issueRecord.issue_category_id;
    newIssue.current.changeLog = issueRecord.oada_issue_change_log__c;
    newIssue.current.category = issueRecord.issue_category;
    newIssue.current.severityId = issueRecord.issue_severity_id;
    newIssue.current.projectTaskId = issueRecord.project_task_id;
    newIssue.current.originalTaskName = issueRecord.project_task_id
      ? projectTasks.current.find(
          (elem) => elem.id == issueRecord.project_task_id,
        ).name
      : "";

    if (issueRecord.issue_stage_id && issueRecord.issue_stage_id > 0) {
      newIssue.current.stage = stageArray.find(
        (stageElem) => issueRecord.issue_stage_id == stageElem.id,
      ).name;
    }

    if (issueRecord.issue_severity_id && issueRecord.issue_severity_id > 0) {
      newIssue.current.severity = severityArray.find(
        (severityElem) => issueRecord.issue_severity_id == severityElem.id,
      ).name;
    }

    if (issueRecord.user_id && issueRecord.user_id > 0) {
      newIssue.current.assignee = userArray.find(
        (userElem) => issueRecord.user_id == userElem.id,
      ).name;
    }
    //}
    setOpenDialog(true);
  };

  const handleClose = () => {
    newIssue.current = newIssueInitial;
    props.waitHandler(false);
    setOpenDialog(false);
  };

  const handleConfirm = () => {
    // remove this if statement to remove default behavior
    if (!newIssue.current.stageId) {
      newIssue.current.stageId = stageOptions[0].id;
    }
    if (!newIssue.current.categoryId) {
      newIssue.current.categoryId = categoryOptions[0].id;
    }
    if (!newIssue.current.userId) {
      newIssue.current.userId = creds.id;
    }
    // end of default behavior section

    if (
      newIssue.current.synopsis &&
      (props.raidType == "assumption" || newIssue.current.stageId)
    ) {
      if (newIssue.current.id) {
        props.updateIssue(newIssue.current, newIssue.current.details);
      } else {
        props.addIssue(newIssue.current, newIssue.current.details);
      }

      handleClose();
    } else {
      setOpenRequiredFieldNotification(true);
    }
  };

  const handleEditorContentsChange = (event) => {
    newIssue.current.details = event.value;
  };

  const nameTemplate = (issueRecord) => {
    return <div className="reqTableCell">{issueRecord.name}</div>;
  };

  const categoryTemplate = (issueRecord) => {
    return <div className="reqTableCell">{issueRecord.issue_category}</div>;
  };

  const synopsisTemplate = (issueRecord) => {
    return (
      <div
        //onClick={handleOpen}
        data-issuerecord={JSON.stringify(issueRecord)}
        className="reqTableSynopsis tour-stop-2"
      >
        {issueRecord.description}
      </div>
    );
  };

  const stageTemplate = (issueRecord) => {
    return (
      <div className="reqTableCell" style={{ textWrap: "wrap" }}>
        {issueRecord.issue_stage}
      </div>
    );
  };

  const severityTemplate = (issueRecord) => {
    return (
      <div className="reqTableCell" style={{ textWrap: "wrap" }}>
        {issueRecord.issue_severity}
      </div>
    );
  };

  const assigneeTemplate = (issueRecord) => {
    return (
      <div className="reqTableCell" style={{ textWrap: "wrap" }}>
        {issueRecord.assignee}
      </div>
    );
  };

  const dateTemplate = (issueRecord) => {
    return genericDateTemplate(issueRecord.date);
  };

  const requiredDateTemplate = (issueRecord) => {
    return genericDateTemplate(issueRecord.date_resolution_required);
  };

  const expectedDateTemplate = (issueRecord) => {
    return genericDateTemplate(issueRecord.date_resolution_expected);
  };

  const resolvedDateTemplate = (issueRecord) => {
    return genericDateTemplate(issueRecord.date_resolved);
  };

  const genericDateTemplate = (dateField) => {
    let dateValue;
    if (!dateField || dateField.toString() == "Invalid Date") {
      dateValue = null;
    } else {
      const monthString =
        dateField.getMonth() + 1 < 10
          ? "0" + (dateField.getMonth() + 1)
          : dateField.getMonth() + 1;
      const dayString =
        dateField.getDate() < 10
          ? "0" + dateField.getDate()
          : dateField.getDate();
      dateValue = dateField.getFullYear() + "-" + monthString + "-" + dayString;
    }
    return (
      <div className="reqTableDate reqTableCell" style={{ textAlign: "left" }}>
        {dateValue}
      </div>
    );
  };

  const headerTemplate = (issueRecord) => {
    return (
      <div id={"__issues" + issueRecord.headerText} className="reqTableHeader">
        {issueRecord.headerText}
      </div>
    );
  };

  const handleNotificationClose = () => {
    setOpenRequiredFieldNotification(false);
  };

  const handleConfirmationClose = () => {
    setOpenConfirmation(false);
  };

  const editOptions = {
    allowEditing: true,
    //allowAdding: true,
    //allowDeleting: true,
    mode: "Normal",
  };

  function formatUndelimitedDate(dateField) {
    return (
      dateField.substring(4, 8) +
      "-" +
      dateField.substring(0, 2) +
      "-" +
      dateField.substring(2, 4)
    );
  }

  const dateFormatParams = {
    params: { format: "yyyy-MM-dd" },
  };

  function endEdit(event) {
    if (editMode.current) {
      if (event.target.nodeName == "HTML") {
        editMode.current = false;
        grid.current.endEdit();
      }
    }
  }

  const actionBegin = (e) => {
    if (e.requestType == "beginEdit") {
      editMode.current = true;
      document.addEventListener("click", endEdit);
    }
  };

  const actionComplete = (e) => {
    if (e.requestType === "beginEdit") {
      // focus the column
      e.form.elements[
        grid.current.element.getAttribute("id") + fieldName
      ].focus();
    }
    if (e.action == "filter") {
      const filterObject = {
        fieldName: e.columns[0].field,
        filterOperator: e.columns[0].operator,
        filterValue: e.columns[0].value,
        predicate: e.columns[0].predicate,
        matchCase: e.columns[0].matchCase,
        ignoreAccent: e.columns[0].ignoreAccent,
      };
      localStorage.setItem("issuesFilterObject", JSON.stringify(filterObject));
    }
    if (e.action == "edit" && e.requestType == "save") {
      const issueDate = Tools.parseDateObject(e.data.date);
      const dateExpected = Tools.parseDateObject(
        e.data.date_resolution_expected,
      );
      const dateRequired = Tools.parseDateObject(
        e.data.date_resolution_required,
      );
      const dateResolved = Tools.parseDateObject(e.data.date_resolved);

      const authString = Tools.getXmlBodyAuthString(creds);
      const urlString = Tools.getInstanceUrl(creds);
      const updateString =
        authString +
        '<Modify type="Issue" enable_custom="1"><Issue><id>' +
        e.data.id +
        "</id><date>" +
        issueDate +
        "</date><date_resolution_expected>" +
        dateExpected +
        "</date_resolution_expected><date_resolution_required>" +
        dateRequired +
        "</date_resolution_required><date_resolved>" +
        dateResolved +
        "</date_resolved></Issue></Modify></request>";

      Tools.fetchPost(updateString, urlString);
      document.removeEventListener("click", endEdit());
    }
  };

  const recordDoubleClick = (e) => {
    fieldName = grid.current.getColumnByIndex(e.cell.cellIndex).field;
    handleOpen(e.rowData);
  };

  const issueStageParams = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: new DataManager(stageOptions),
      fields: { text: "name", value: "name" },
      query: new Query(),
    },
  };

  const issueCategoryParams = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: new DataManager(categoryOptions),
      fields: { text: "name", value: "name" },
      query: new Query(),
    },
  };

  const issueSeverityParams = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: new DataManager(severityOptions),
      fields: { text: "name", value: "name" },
      query: new Query(),
    },
  };

  const userParams = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: new DataManager(userOptions),
      fields: { text: "name", value: "name" },
      query: new Query(),
    },
  };

  const filterSettings = { type: "Excel" };

  useEffect(() => {
    if (grid.current) {
      const filterString = localStorage.getItem("issuesFilterObject");
      if (filterString) {
        grid.current.filterByColumn(JSON.parse(filterString));
        isDirty(!dirty);
      }
    }
  }, [grid.current]);

  useEffect(() => {
    const instanceUrl = Tools.getInstanceUrl(creds);
    const restTasksUrl = instanceUrl.replace(
      "api.pl",
      "rest/v1/project-tasks?q=projectId EQUAL " + projectObject.id,
    );
    const restPhasesUrl = instanceUrl.replace(
      "api.pl",
      "rest/v1/project-phases?q=projectId EQUAL " + projectObject.id,
    );
    const restMilestonesUrl = instanceUrl.replace(
      "api.pl",
      "rest/v1/project-milestones?q=projectId EQUAL " + projectObject.id,
    );
    Tools.refreshSPPToken(creds).then((accessToken) => {
      Tools.fetchGet(restTasksUrl, "Bearer " + accessToken).then(
        (responseTasks) => {
          Tools.fetchGet(restPhasesUrl, "Bearer " + accessToken).then(
            (responsePhases) => {
              Tools.fetchGet(restMilestonesUrl, "Bearer " + accessToken).then(
                (responseMilestones) => {
                  projectTasks.current = [
                    ...responseTasks.data,
                    ...responsePhases.data,
                    ...responseMilestones.data,
                  ].map((item) => ({
                    name: item.name,
                    id: item.id,
                  }));
                },
              );
            },
          );
        },
      );
    });
  }, []);

  useEffect(() => {
    const globalDataObject = new GlobalData(creds);
    //props.waitHandler(true);
    globalDataObject.populateTable("IssueStage").then(() => {
      const stageArray = JSON.parse(
        localStorage.getItem(creds.company + "|IssueStage"),
      );

      globalDataObject.populateTable("IssueCategory").then(() => {
        const categoryArray = JSON.parse(
          localStorage.getItem(creds.company + "|IssueCategory"),
        );

        globalDataObject.populateTable("IssueSeverity").then(() => {
          const severityArray = JSON.parse(
            localStorage.getItem(creds.company + "|IssueSeverity"),
          );

          /*Tools.refreshSPPToken(creds).then((accessToken) => {
            Tools.fetchGet(restTasksUrl, "Bearer " + accessToken).then(
              (response) => {
                console.log(response); // array of objects -- data[]

                projectTasks.current = response.data.map((task) => {
                  return { name: task.name, id: task.id };
                });
*/
          const userArray = JSON.parse(
            localStorage.getItem(creds.company + "|User"),
          );

          const issueArray = [];
          if (props.issueArray.length > 0) {
            props.issueArray.forEach((issueElem) => {
              const stageName = issueElem.issue_stage_id
                ? stageArray.find(
                    (stageElem) => issueElem.issue_stage_id == stageElem.id,
                  ).name
                : "";
              const categoryName = issueElem.issue_category_id
                ? categoryArray.find(
                    (categoryElem) =>
                      issueElem.issue_category_id == categoryElem.id,
                  ).name
                : "";
              const severityName =
                issueElem.issue_severity_id &&
                issueElem.issue_severity_id != "-1"
                  ? severityArray.find(
                      (severityElem) =>
                        issueElem.issue_severity_id == severityElem.id,
                    ).name
                  : "";
              const userName = issueElem.user_id
                ? userArray.find(
                    (userElem) => parseInt(issueElem.user_id) == userElem.id,
                  ).name
                : "";
              if (typeof issueElem.date == "string") {
                issueElem.date = new Date(
                  formatUndelimitedDate(issueElem.date),
                );
                issueElem.date.setTime(
                  issueElem.date.getTime() +
                    issueElem.date.getTimezoneOffset() * 60 * 1000,
                );
              }
              if (typeof issueElem.date_resolution_required == "string") {
                issueElem.date_resolution_required = new Date(
                  formatUndelimitedDate(issueElem.date_resolution_required),
                );
                issueElem.date_resolution_required.setTime(
                  issueElem.date_resolution_required.getTime() +
                    issueElem.date_resolution_required.getTimezoneOffset() *
                      60 *
                      1000,
                );
              }
              if (typeof issueElem.date_resolution_expected == "string") {
                issueElem.date_resolution_expected = new Date(
                  formatUndelimitedDate(issueElem.date_resolution_expected),
                );
                issueElem.date_resolution_expected.setTime(
                  issueElem.date_resolution_expected.getTime() +
                    issueElem.date_resolution_expected.getTimezoneOffset() *
                      60 *
                      1000,
                );
              }
              if (typeof issueElem.date_resolved == "string") {
                issueElem.date_resolved = new Date(
                  formatUndelimitedDate(issueElem.date_resolved),
                );
                issueElem.date_resolved.setTime(
                  issueElem.date_resolved.getTime() +
                    issueElem.date_resolved.getTimezoneOffset() * 60 * 1000,
                );
              }

              issueArray.push({
                ...issueElem,
                issue_stage: stageName,
                issue_category: categoryName,
                issue_severity: severityName,
                assignee: userName,
              });
            });
          }

          const issueEditor = (
            <RequirementsEditor
              handleEditorContentsChange={handleEditorContentsChange}
              reqDetails={newIssue.current.details}
              showComparisons={false}
              height="50vh"
              changeLog={newIssue.current.changeLog}
            />
          );

          const groupOptions = {
            columns: ["issue_category"],
            showDropArea: false,
            captionTemplate: '<span style="color:black">${key}</span>',
          };

          const handleDeleteConfirm = () => {
            idToDelete.current = newIssue.current.id;
            //props.handleClose();
            setOpenDeleteConfirm(true);
          };

          const handleCloseDeleteConfirm = (event) => {
            console.log(event.target.value);
            setOpenDeleteConfirm(false);
            if (event.target.value == "confirm") {
              handleDelete(idToDelete.current);
            }
            isDirty(!dirty);
          };

          const handleDelete = (reqId) => {
            props.deleteIssue(reqId);
            //props.handleClose();
            handleClose();
          };

          const content = (
            <Fragment>
              <Tour initialState={initialTourState} id={TOUR_ID} />
              <Box>
                <ProjectTitleBar
                  aiData={issueArray}
                  aiDataType="raid items"
                  topPosition={100}
                  docPage="RAID TAB.pdf"
                />

                <Box
                  sx={{
                    width: "100%",
                    display: "inline-block",
                    position: "fixed",
                    top: 140,
                    backgroundColor: "#aaaaaa",
                    zIndex: 100,
                  }}
                >
                  <Box
                    justifyContent="flex-start"
                    gap="10px"
                    display="flex"
                    border="none"
                    sx={{ padding: "0px 10px 5px 10px" }}
                  >
                    {props.raidType == "all" ? null : (
                      <Button
                        className="tour-stop-3"
                        data-raidtype={props.raidType}
                        id="__issuesAddIssue"
                        variant="contained"
                        onClick={helpMode ? null : handleAdd}
                        sx={{
                          border: "solid 1px",
                          backgroundColor: "darkslategray",
                          borderRadius: "10px",
                        }}
                      >
                        Add&nbsp;
                        <span
                          style={{ textTransform: "uppercase" }}
                          data-raidtype={props.raidType}
                        >
                          {props.raidType}
                        </span>
                      </Button>
                    )}
                  </Box>
                </Box>

                <Box
                  sx={{
                    top: props.raidType == "all" ? "5px" : "45px",
                    position: "absolute",
                  }}
                >
                  <GridComponent
                    id="__issuesGrid"
                    allowSorting={true}
                    showColumnMenu={true}
                    allowFiltering={true}
                    filterSettings={filterSettings}
                    enableStickyHeader={true}
                    editSettings={editOptions}
                    dataSource={issueArray}
                    ref={(g) => (grid.current = g)}
                    recordClick={recordDoubleClick}
                    actionComplete={actionComplete}
                    actionBegin={actionBegin}
                    cssClass="issuesGrid"
                    //allowGrouping={props.raidType == "all" ? true : false}
                    //groupSettings={groupOptions}
                    //toolbar={toolbarOptions}
                    //enablePersistence={true}
                  >
                    <Inject
                      services={[
                        Sort,
                        ColumnMenu,
                        Filter,
                        Edit,
                        Group /*, Toolbar*/,
                      ]}
                    />
                    <ColumnsDirective>
                      <ColumnDirective
                        isPrimaryKey={true}
                        allowEditing={false}
                        field="name"
                        headerText="Name"
                        textAlign="Left"
                        width="7"
                        template={nameTemplate}
                        headerTemplate={headerTemplate}
                        customAttributes={{ class: "reqTableCell" }}
                      />
                      {props.raidType == "all" ? (
                        <ColumnDirective
                          allowEditing={false}
                          field="issue_category"
                          headerText="Type"
                          textAlign="Left"
                          width="6"
                          //visible={false}
                          template={categoryTemplate}
                          headerTemplate={headerTemplate}
                          customAttributes={{ class: "reqTableCell" }}
                        />
                      ) : null}
                      <ColumnDirective
                        field="date"
                        headerText="Date"
                        width="6"
                        editType="datepickeredit"
                        edit={dateFormatParams}
                        template={dateTemplate}
                        headerTemplate={headerTemplate}
                        filter={{
                          type: "Excel",
                          itemTemplate: dateTemplate,
                        }}
                        customAttributes={{ class: "reqTableCell" }}
                      />
                      <ColumnDirective
                        field="description"
                        headerText="Synopsis"
                        textAlign="Left"
                        width="25"
                        template={synopsisTemplate}
                        headerTemplate={headerTemplate}
                        customAttributes={{ class: "reqTableCell" }}
                      />
                      {props.raidType == "assumption" ? null : (
                        <ColumnDirective
                          field="issue_stage"
                          headerText="Stage"
                          textAlign="Left"
                          width="7"
                          editType="dropdownedit"
                          edit={issueStageParams}
                          template={stageTemplate}
                          headerTemplate={headerTemplate}
                          customAttributes={{ class: "reqTableCell" }}
                        />
                      )}
                      {props.raidType == "assumption" ? null : (
                        <ColumnDirective
                          field="issue_severity"
                          headerText="Priority"
                          textAlign="Left"
                          width="7"
                          editType="dropdownedit"
                          edit={issueSeverityParams}
                          template={severityTemplate}
                          headerTemplate={headerTemplate}
                          customAttributes={{ class: "reqTableCell" }}
                        />
                      )}
                      {props.raidType == "assumption" ? null : (
                        <ColumnDirective
                          field="assignee"
                          headerText="Assignee"
                          textAlign="Left"
                          width="10"
                          editType="dropdownedit"
                          edit={userParams}
                          template={assigneeTemplate}
                          headerTemplate={headerTemplate}
                          visible={
                            props.raidType == "assumption" ? false : true
                          }
                          customAttributes={{ class: "reqTableCell" }}
                        />
                      )}
                      {props.raidType == "assumption" ? null : (
                        <ColumnDirective
                          field="date_resolution_required"
                          headerText="Required"
                          textAlign="Center"
                          width="8"
                          editType="datepickeredit"
                          edit={dateFormatParams}
                          template={requiredDateTemplate}
                          headerTemplate={headerTemplate}
                          customAttributes={{ class: "reqTableCell" }}

                          //customAttributes={{ class: "reqTableName" }}
                        />
                      )}
                      {props.raidType == "assumption" ||
                      useExpectedDate == false ? null : (
                        <ColumnDirective
                          field="date_resolution_expected"
                          headerText="Expected"
                          textAlign="Center"
                          width="8"
                          editType="datepickeredit"
                          edit={dateFormatParams}
                          template={expectedDateTemplate}
                          headerTemplate={headerTemplate}
                          customAttributes={{ class: "reqTableCell" }}
                          //customAttributes={{ class: "reqTableName" }}
                        />
                      )}
                      {props.raidType == "assumption" ? null : (
                        <ColumnDirective
                          field="date_resolved"
                          headerText="Resolved"
                          textAlign="Center"
                          width="8"
                          editType="datepickeredit"
                          edit={dateFormatParams}
                          template={resolvedDateTemplate}
                          headerTemplate={headerTemplate}
                          customAttributes={{ class: "reqTableCell" }}
                          //visible={props.raidType == "assumption" ? false : true}
                          //customAttributes={{ class: "reqTableName" }}
                        />
                      )}
                    </ColumnsDirective>
                  </GridComponent>
                </Box>
              </Box>
              <Dialog
                open={openDialog}
                onClose={handleClose}
                //fullWidth={true}
                //maxWidth="md"
                fullScreen
                sx={{ textAlign: "center" }}
              >
                <Box
                  sx={{
                    backgroundColor: "gainsboro",
                    padding: "10px",
                    border: "solid 2px",
                    overflowY: "scroll",
                    height: "95vh",
                  }}
                >
                  <ProjectTitleBar
                    projectObject={projectObject}
                    docPage="RAID TAB.pdf"
                    top={48}
                    inDialog={true}
                  />
                  <br></br>
                  <br></br>

                  <Box
                    display="flex"
                    sx={{ paddingTop: "8px", paddingBottom: "8px" }}
                  >
                    <Typography
                      className="reqAccordionHeaderShort"
                      sx={{ textTransform: "capitalize" }}
                    >
                      {newIssue.current.category}&nbsp;Synopsis
                    </Typography>
                    <Typography
                      id="name"
                      sx={{
                        width: "100px",
                        color: "white",
                        fontWeight: "bold",
                        backgroundColor: "#643f69",
                        borderRadius: "10px",
                        textAlign: "center",
                        marginLeft: "10px",
                      }}
                    >
                      {newIssue.current.name}
                    </Typography>
                  </Box>
                  <Fragment>
                    <Table
                      id="mainRAIDFormTable"
                      sx={{
                        backgroundColor: "white",
                      }}
                    >
                      <TableBody>
                        <TableRow>
                          <TableCell>
                            <Table id="leftRAIDFormTable">
                              <TableBody>
                                <TableRow>
                                  <TableCell
                                    className="reqDetailsTableCell"
                                    id="__issuesSynopsis"
                                  >
                                    <TextField
                                      required
                                      id="synopsis"
                                      defaultValue={newIssue.current.synopsis}
                                      onChange={handleTextFieldValueChange}
                                      variant="standard"
                                      label="Synopsis"
                                      sx={{
                                        margin: "10px 10px",
                                        width: "550px",
                                      }}
                                    ></TextField>
                                  </TableCell>
                                </TableRow>
                                {props.raidType == "assumption" ? null : (
                                  <TableRow>
                                    <TableCell
                                      className="reqDetailsTableCell"
                                      id="__issuesStage"
                                    >
                                      <DropDownListComponent
                                        sortOrder="Ascending"
                                        required
                                        id="stageDropdown"
                                        defaultValue={
                                          newIssue.current.stage ||
                                          stageOptions[0].name
                                        }
                                        dataSource={stageOptions}
                                        fields={dropdownFieldDef}
                                        select={handleStageValueChange}
                                        placeholder="&nbsp;&nbsp;&nbsp;Stage *"
                                        width="350px"
                                        cssClass="reqDialogDropdown"
                                        floatLabelType="Always"
                                      />
                                    </TableCell>
                                  </TableRow>
                                )}
                                {props.raidType == "assumption" ? null : (
                                  <TableRow>
                                    <TableCell
                                      className="reqDetailsTableCell"
                                      id="__issuesUser"
                                    >
                                      <DropDownListComponent
                                        sortOrder="Ascending"
                                        required
                                        id="assigneeDropdown"
                                        defaultValue={
                                          newIssue.current.assignee ||
                                          creds.name
                                        }
                                        dataSource={userOptions}
                                        fields={dropdownFieldDef}
                                        select={handleAssigneeValueChange}
                                        placeholder="&nbsp;&nbsp;&nbsp;Assignee"
                                        width="350px"
                                        cssClass="reqDialogDropdown"
                                        floatLabelType="Always"
                                      />
                                    </TableCell>
                                  </TableRow>
                                )}
                                <TableRow>
                                  <TableCell
                                    className="reqDetailsTableCell"
                                    id="__issuesCategory"
                                  >
                                    <DropDownListComponent
                                      sortOrder="Ascending"
                                      required
                                      id="categoryDropdown"
                                      defaultValue={newIssue.current.category}
                                      dataSource={categoryOptions}
                                      fields={dropdownFieldDef}
                                      select={handleCategoryValueChange}
                                      placeholder="&nbsp;&nbsp;&nbsp;RAID Category"
                                      width="350px"
                                      cssClass="reqDialogDropdown"
                                      floatLabelType="Always"
                                    />
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableCell>
                          <TableCell sx={{ verticalAlign: "top" }}>
                            <Table id="rightRAIDFormTable">
                              <TableBody>
                                {props.raidType == "assumption" ? null : (
                                  <TableRow>
                                    <TableCell
                                      width="45%"
                                      className="reqDetailsTableCell"
                                      id="__issuesRequired"
                                    >
                                      <DesktopDatePicker
                                        id="date_resolution_required"
                                        label={
                                          props.raidType == "risk"
                                            ? "Action Plan Required"
                                            : props.raidType == "decision"
                                              ? "Decision Required"
                                              : props.raidType == "action"
                                                ? "Due Date"
                                                : "Resolution Required"
                                        }
                                        onChange={handleDateReqValueChange}
                                        slotProps={{
                                          textField: {
                                            variant: "standard",
                                          },
                                        }}
                                        defaultValue={
                                          newIssue.current.dateReq &&
                                          newIssue.current.dateReq !=
                                            "Invalid Date"
                                            ? dayjs(newIssue.current.dateReq)
                                            : null
                                        }
                                      />
                                    </TableCell>
                                  </TableRow>
                                )}
                                {useExpectedDate == false ? null : (
                                  <TableRow>
                                    <TableCell
                                      width="45%"
                                      className="reqDetailsTableCell"
                                      id="__issuesExpected"
                                    >
                                      <DesktopDatePicker
                                        label={
                                          props.raidType == "risk"
                                            ? "Action Plan Expected"
                                            : props.raidType == "decision"
                                              ? "Decision Expected"
                                              : "Resolution Expected"
                                        }
                                        id="date_resolution_expected"
                                        onChange={handleDateExpValueChange}
                                        slotProps={{
                                          textField: {
                                            variant: "standard",
                                          },
                                        }}
                                        defaultValue={
                                          newIssue.current.dateExp &&
                                          newIssue.current.dateExp !=
                                            "Invalid Date"
                                            ? dayjs(newIssue.current.dateExp)
                                            : null
                                        }
                                      />
                                    </TableCell>
                                  </TableRow>
                                )}
                                <TableRow>
                                  <TableCell
                                    width="45%"
                                    className="reqDetailsTableCell"
                                    id="__issuesResolved"
                                  >
                                    {props.raidType != "assumption" ? (
                                      <DesktopDatePicker
                                        ref={(ddp) => (resolvedRef = ddp)}
                                        label={
                                          props.raidType == "risk"
                                            ? "Risk Closed"
                                            : props.raidType == "decision"
                                              ? "Decision Made"
                                              : "Resolved"
                                        }
                                        id="date_resolved"
                                        onChange={handleDateResValueChange}
                                        slotProps={{
                                          textField: {
                                            variant: "standard",
                                          },
                                        }}
                                        defaultValue={
                                          newIssue.current.dateRes &&
                                          newIssue.current.dateRes !=
                                            "Invalid Date"
                                            ? dayjs(newIssue.current.dateRes)
                                            : null
                                        }
                                      />
                                    ) : null}
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell
                                    className="reqDetailsTableCell"
                                    id="__issuesTask"
                                  >
                                    <br></br>
                                    <br></br>
                                    <DropDownListComponent
                                      sortOrder="Ascending"
                                      required
                                      id="taskDropdown"
                                      defaultValue={
                                        newIssue.current.originalTaskName
                                      }
                                      dataSource={projectTasks.current}
                                      fields={dropdownFieldDef}
                                      select={handleTaskValueChange}
                                      placeholder="Associated Task"
                                      width="350px"
                                      cssClass="reqDialogDropdown"
                                      floatLabelType="Always"
                                    />
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell
                                    className="reqDetailsTableCell"
                                    id="__issuesSeverity"
                                  >
                                    <DropDownListComponent
                                      sortOrder="Ascending"
                                      required
                                      id="severityDropdown"
                                      defaultValue={newIssue.current.severity}
                                      dataSource={severityOptions}
                                      fields={dropdownFieldDef}
                                      select={handleSeverityValueChange}
                                      placeholder="Priority"
                                      width="350px"
                                      cssClass="reqDialogDropdown"
                                      floatLabelType="Always"
                                    />
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Fragment>

                  <Typography
                    className="reqAccordionHeader"
                    sx={{
                      margin: "10px 0px",
                      textTransform: "capitalize",
                    }}
                  >
                    {newIssue.current.category}&nbsp;Details
                  </Typography>

                  {issueEditor}

                  <DialogActions sx={{ justifyContent: "center" }}>
                    <Button
                      className="dialogConfirmCancelButton"
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="dialogConfirmCancelButton"
                      onClick={handleConfirm}
                    >
                      Save
                    </Button>
                    {newIssue.current.name ? (
                      <Button
                        className="dialogDeleteButton"
                        onClick={handleDeleteConfirm}
                      >
                        Delete
                      </Button>
                    ) : null}
                  </DialogActions>
                </Box>
              </Dialog>
              <Dialog
                open={openDeleteConfirm}
                onClose={handleCloseDeleteConfirm}
              >
                <DialogTitle id="alert-dialog-title">
                  {"Delete RAID Item?"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    You have requested to delete this RAID item. Please confirm
                    this action.
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={handleCloseDeleteConfirm}
                    value="cancel"
                    autoFocus
                  >
                    Cancel
                  </Button>
                  <Button onClick={handleCloseDeleteConfirm} value="confirm">
                    Confirm
                  </Button>
                </DialogActions>
              </Dialog>
              <Snackbar
                open={openRequiredFieldNotification}
                autoHideDuration={5000}
                onClose={handleNotificationClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
              >
                <Alert
                  variant="filled"
                  onClose={handleNotificationClose}
                  severity="error"
                  sx={{ width: "100%", fontSize: "large" }}
                >
                  Save failed - Synopsis and Stage are required fields.
                </Alert>
              </Snackbar>
              <Snackbar
                open={openConfirmation}
                autoHideDuration={4000}
                onClose={handleConfirmationClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
              >
                <Alert
                  variant="filled"
                  onClose={handleConfirmationClose}
                  severity="success"
                  sx={{ width: "100%", fontSize: "large" }}
                >
                  Update Successful
                </Alert>
              </Snackbar>
            </Fragment>
          );
          setPageContent(content);
          if (props.loadCompleted) {
            props.waitHandler(false);
            props.resetLoadCompleted();
          }
        });
      });
    });
    //});
    //});
  }, [
    props.issueArray,
    props.raidType,
    openDialog,
    openDeleteConfirm,
    openRequiredFieldNotification,
    dirty,
  ]);

  return pageContent;
}
export default RAIDComponent;

RAIDComponent.propTypes = {
  issueArray: PropTypes.array,
  waitHandler: PropTypes.func,
  updateIssue: PropTypes.func,
  addIssue: PropTypes.func,
  deleteIssue: PropTypes.func,
  projectTeam: PropTypes.array,
  loadCompleted: PropTypes.bool,
  resetLoadCompleted: PropTypes.func,
  raidType: PropTypes.string,
};

/*

                  <Button
                    className="dialogConfirmCancelButtonWide"
                    onClick={handleSaveCreate}
                  >
                    Save and Create Another
                  </Button>
                )}
*/
